/**
 * 各状态文档
 * https://alidocs.dingtalk.com/i/nodes/mdvQnONayjBJKmel2epnWPY2MeXzp5o0?utm_source=dingdoc_doc&utm_medium=dingdoc_doc_plugin_card&nav=spaces&subNav=9JOGOypQVOBjnX4Q&navQuery=spaceId%3D9JOGOypQVOBjnX4Q
 */

import { useEffect } from 'react'
import {
  CrowdfundingActivityStatusEnum,
  getPreSaleActivity_marketingModule_crowdfundingActivity,
} from '~/graphqls/types'
import { countdownFormatFn, useCountdownDur } from '~/hooks/useCounter'

interface Props {
  remoteData: getPreSaleActivity_marketingModule_crowdfundingActivity
  status: CrowdfundingActivityStatusEnum | null
  countdownCallback: () => void
}

export default function ActivityStatus({
  remoteData,
  status,
  countdownCallback,
}: Props) {
  let countDownDur = 0
  // 预售开始倒计时
  if (status === CrowdfundingActivityStatusEnum.UN_START) {
    countDownDur = remoteData.startTimeDiff || 0
  }
  // 预售结束倒计时
  if (
    status === CrowdfundingActivityStatusEnum.START ||
    status === CrowdfundingActivityStatusEnum.PRESALE_END
  ) {
    countDownDur = remoteData.crowdfunding?.endTimeDiff || 0
  }

  const countDown = useCountdownDur(countDownDur)

  useEffect(() => {
    if (countDown === 0) {
      if (status === CrowdfundingActivityStatusEnum.UN_START) {
        countdownCallback()
      } else if (status === CrowdfundingActivityStatusEnum.START) {
        countdownCallback()
      }
    }
  }, [countDown, status])

  if (status === CrowdfundingActivityStatusEnum.UN_START) {
    return (
      <>
        <div className="text-neutral-50 text-base whitespace-nowrap">
          {countdownFormatFn(countDown)}
        </div>
        <div className="text-xs text-neutral-400">预售即将开售</div>
      </>
    )
  }

  if (status === CrowdfundingActivityStatusEnum.START) {
    return (
      <>
        <div className="text-neutral-50 text-base whitespace-nowrap">
          {countdownFormatFn(countDown)}
        </div>
        <div className="text-xs text-neutral-400">预售剩余时间</div>
      </>
    )
  }

  if (status === CrowdfundingActivityStatusEnum.SUCCESS) {
    return <div className="text-base whitespace-nowrap">请等待作品发放</div>
  }

  if (status === CrowdfundingActivityStatusEnum.PUBLIC) {
    return (
      <>
        <div className="text-neutral-50 text-base whitespace-nowrap">
          当前处于公售期
        </div>
        <div className="text-xs text-neutral-400">预售已结束</div>
      </>
    )
  }

  if (status === CrowdfundingActivityStatusEnum.FAILED) {
    return (
      <>
        <div className="text-error text-base whitespace-nowrap">
          请耐心等待退款
        </div>
        <div className="text-xs text-neutral-400">预售失败</div>
      </>
    )
  }

  if (status === CrowdfundingActivityStatusEnum.FAILED_REFUNDED) {
    return (
      <>
        <div className="text-neutral-50 text-base">已退款</div>
        <div className="text-xs text-neutral-400">预售失败</div>
      </>
    )
  }

  if (status === CrowdfundingActivityStatusEnum.PRESALE_END) {
    return (
      <>
        <div className="text-neutral-50 text-base whitespace-nowrap">
          {countdownFormatFn(countDown)}
        </div>
        <div className="text-xs text-neutral-400">预售剩余时间</div>
      </>
    )
  }

  return <div className="text-base">活动已结束</div>
}
